import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import axios from 'axios';
import { AnimatedText, AnimatedSection } from '../components/AnimatedSection';
import { Search } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const filters = [
  { id: 'all', label: 'Tümü' },
  { id: 'corporate', label: 'Kurumsal' },
  { id: 'wedding', label: 'Düğün' },
  { id: 'launch', label: 'Lansman' },
  { id: 'private', label: 'Özel' },
  { id: 'graduation', label: 'Mezuniyet' },
];

const fallbackPortfolio = [

  {
    id: 'nisan-1',
    title: 'Aynalı Karşılama Alanı',
    category: 'private',
    location: 'İstanbul',
    year: '2026',
    image_url: '/images/portfolio/nisan-1.jpeg',
    description: 'Misafirleri ilk anda etkileyen aynalı karşılama panosu ve zarif açık hava dekorasyonu.',
    details: 'Ayna pano, karşılama alanı, çiçek dekoru, mum ve masa styling.'
  },
  {
    id: 'nisan-2',
    title: 'Bahçe Davet Masası',
    category: 'private',
    location: 'İstanbul',
    year: '2026',
    image_url: '/images/portfolio/nisan-2.jpeg',
    description: 'Açık havada sıcak, doğal ve estetik bir davet masası deneyimi.',
    details: 'Masa düzeni, ahşap sandalye, çiçek yerleşimi ve bahçe konsepti.'
  },
  {
    id: 'nisan-3',
    title: 'Açık Hava Nişan Fon Tasarımı',
    category: 'private',
    location: 'İstanbul',
    year: '2026',
    image_url: '/images/portfolio/nisan-3.jpeg',
    description: 'Bahçe konseptleri için sade, şık ve romantik açık hava nişan fonu.',
    details: 'Drape fon, çiçek düzeni, dış mekan kurulum ve konsept tasarım.'
  },
  {
    id: 'nisan-4',
    title: 'Floral Dekor Detayları',
    category: 'private',
    location: 'İstanbul',
    year: '2026',
    image_url: '/images/portfolio/nisan-4.jpeg',
    description: 'Renk, doku ve çiçek kompozisyonlarıyla hazırlanmış premium dekor detayları.',
    details: 'Canlı çiçek, masa üstü styling, fon dekorasyonu ve detay kompozisyonu.'
  },
  {
    id: 'nisan-5',
    title: 'Özel İkram Sunum Alanı',
    category: 'private',
    location: 'İstanbul',
    year: '2026',
    image_url: '/images/portfolio/nisan-5.jpeg',
    description: 'Davet atmosferini tamamlayan estetik ikram ve servis alanı kurulumu.',
    details: 'İkram masası, kumaş drape, sunum standları ve masa dekorasyonu.'
  },
  {
    id: 'nisan-6',
    title: 'Butik Nişan Oturma Alanı',
    category: 'private',
    location: 'İstanbul',
    year: '2026',
    image_url: '/images/portfolio/nisan-6.jpeg',
    description: 'Butik nişan ve söz organizasyonları için özel hazırlanmış zarif oturma alanı.',
    details: 'Oturma alanı, çiçek düzeni, beyaz fon, ahşap sandalye ve konsept dekor.'
  },
  {
    id: 'nisan-7',
    title: 'Zarif Nişan Detay Alanı',
    category: 'private',
    location: 'İstanbul',
    year: '2026',
    image_url: '/images/portfolio/nisan-7.jpeg',
    description: 'Doğal çiçekler, beyaz drape fon ve ahşap detaylarla tasarlanmış zarif nişan konsepti.',
    details: 'Fotoğraf alanı, çiçek dekorasyonu, masa styling ve özel konsept tasarımı.'
  },


  {
    id: 'graduation-1',
    title: 'Mezuniyet Sahne Kurulumu',
    category: 'graduation',
    location: 'Ankara',
    year: '2025',
    image_url: '/images/portfolio/mezuniyet-2.PNG',
    description: 'Mezuniyet törenleri için sahne, dekor, oturma düzeni ve tören akışının profesyonel planlanması.',
    details: 'Sahne kurulumu, LED ekran, ses-ışık sistemi, çiçek dekorasyonu ve tören koordinasyonu.'
  },
  {
    id: 'graduation-2',
    title: 'AYBÜ Mezuniyet Töreni',
    category: 'graduation',
    location: 'Ankara',
    year: '2025',
    image_url: '/images/portfolio/mezuniyet-1.PNG',
    description: 'Kurumsal kimliğe uygun, güçlü ve prestijli mezuniyet sahne tasarımı.',
    details: 'Sahne, truss sistem, ışık, ses, podyum ve seremoni alanı kurulumu.'
  },
  {
    id: 'graduation-3',
    title: 'Tören Alanı Tasarımı',
    category: 'graduation',
    location: 'Ankara',
    year: '2025',
    image_url: '/images/portfolio/mezuniyet-3.PNG',
    description: 'Açık hava mezuniyet törenleri için estetik ve işlevsel alan planlaması.',
    details: 'Oturma düzeni, yürüyüş yolu, sahne önü dekorasyonu ve protokol akışı.'
  },
  {
    id: 'graduation-4',
    title: 'Class of 2025 Dekorasyonu',
    category: 'graduation',
    location: 'Ankara',
    year: '2025',
    image_url: '/images/portfolio/mezuniyet-4.PNG',
    description: 'Mezuniyet ruhunu yansıtan özel dekor, fotoğraf alanı ve sahne çevresi tasarımı.',
    details: 'Balon dekoru, çiçek tasarımı, karşılama alanı ve fotoğraf noktaları.'
  },
  {
    id: 'event-1',
    title: 'Açık Hava Etkinlik Alanı',
    category: 'corporate',
    location: 'Antalya',
    year: '2026',
    image_url: '/images/events/corporate-day-1.jpeg',
    description: 'Açık hava davetleri, marka etkinlikleri ve kurumsal buluşmalar için profesyonel alan kurulumu.',
    details: 'Sahne, ses-ışık, masa düzeni, kokteyl alanı ve teknik prodüksiyon.'
  },
  {
    id: 'event-2',
    title: 'Outdoor Sahne & Kokteyl',
    category: 'launch',
    location: 'Antalya',
    year: '2026',
    image_url: '/images/events/corporate-day-2.jpeg',
    description: 'Lansman ve özel marka etkinlikleri için açık hava sahne ve kokteyl alanı kurulumu.',
    details: 'Sahne, truss, LED ekran, ses-ışık ve davet alanı yönetimi.'
  },
  {
    id: 'event-3',
    title: 'Disco Konsept Etkinlik',
    category: 'private',
    location: 'İstanbul',
    year: '2026',
    image_url: '/images/events/disco-night.jpeg',
    description: 'Gece etkinlikleri ve özel davetler için dikkat çekici konsept tasarımlar.',
    details: 'Konsept dekor, ışık, fotoğraf alanı ve özel etkinlik atmosferi.'
  },

  {
    id: 'corporate-2',
    title: 'Kurumsal Davet Masası',
    category: 'corporate',
    location: 'İstanbul',
    year: '2026',
    image_url: '/images/portfolio/kurumsal-2.jpeg',
    description: 'Şirket davetleri ve kurumsal etkinlikler için şık masa düzeni ve profesyonel atmosfer.',
    details: 'Masa düzeni, çiçek, dekoratif detaylar ve misafir deneyimi.'
  },
  {
    id: 'corporate-3',
    title: 'Kurumsal Kokteyl Alanı',
    category: 'corporate',
    location: 'İstanbul',
    year: '2026',
    image_url: '/images/portfolio/kurumsal-3.jpeg',
    description: 'Marka etkinlikleri için hazırlanan kokteyl, ikram ve karşılama konsepti.',
    details: 'İkram alanı, sunum düzeni, marka atmosferi ve operasyon yönetimi.'
  },
  {
    id: 'corporate-4',
    title: 'Kurumsal Fotoğraf Alanı',
    category: 'corporate',
    location: 'İstanbul',
    year: '2026',
    image_url: '/images/portfolio/kurumsal-4.jpeg',
    description: 'Kurumsal etkinlikler için dikkat çekici fotoğraf ve karşılama alanı kurulumu.',
    details: 'Arka fon, balon/dekor çalışması, yönlendirme ve sahneleme.'
  },

  {
    id: 'wedding-1',
    title: 'Premium Düğün Sahne Tasarımı',
    category: 'wedding',
    location: 'İstanbul',
    year: '2026',
    image_url: '/images/portfolio/dugun-1.jpeg',
    description: 'Düğün organizasyonları için zarif, romantik ve premium sahne dekorasyonu.',
    details: 'Gelin-damat alanı, çiçek dekoru, ışık, fon ve konsept tasarım.'
  },
  {
    id: 'wedding-2',
    title: 'Düğün Davet Detayları',
    category: 'wedding',
    location: 'İstanbul',
    year: '2026',
    image_url: '/images/portfolio/dugun-2.jpeg',
    description: 'Davetli deneyimini güçlendiren masa, kart ve detay odaklı düğün tasarımı.',
    details: 'Masa kartları, dekoratif detaylar, konsept bütünlüğü ve sunum.'
  },
  {
    id: 'wedding-3',
    title: 'Gece Düğün Konsepti',
    category: 'wedding',
    location: 'İstanbul',
    year: '2026',
    image_url: '/images/portfolio/dugun-3.jpeg',
    description: 'Işık, ambiyans ve alan düzeniyle oluşturulan etkileyici gece düğün atmosferi.',
    details: 'Aydınlatma, mekan düzeni, oturma planı ve atmosfer yönetimi.'
  },
  {
    id: 'wedding-4',
    title: 'Açık Alan Düğün Düzeni',
    category: 'wedding',
    location: 'İstanbul',
    year: '2026',
    image_url: '/images/portfolio/dugun-4.jpeg',
    description: 'Açık alan düğünleri için doğal, şık ve davetli odaklı masa yerleşimi.',
    details: 'Açık alan planlama, masa dizilimi, çiçek ve dekorasyon.'
  },

  {
    id: 'launch-1',
    title: 'Lansman Kırmızı Halı Alanı',
    category: 'launch',
    location: 'İstanbul',
    year: '2026',
    image_url: '/images/portfolio/lansman-1.jpeg',
    description: 'Açılış ve lansman etkinlikleri için prestijli kırmızı halı karşılama alanı.',
    details: 'Kırmızı halı, bariyer, karşılama, fotoğraf alanı ve akış yönetimi.'
  },
  {
    id: 'launch-2',
    title: 'Lansman Masa Konsepti',
    category: 'launch',
    location: 'İstanbul',
    year: '2026',
    image_url: '/images/portfolio/lansman-2.jpeg',
    description: 'Ürün ve marka lansmanları için premium masa ve dekor tasarımı.',
    details: 'Masa tasarımı, çiçek, ışık, konsept ve sunum alanı.'
  },
  {
    id: 'launch-3',
    title: 'Lansman İkram Sunumu',
    category: 'launch',
    location: 'İstanbul',
    year: '2026',
    image_url: '/images/portfolio/lansman-3.jpeg',
    description: 'Lansman davetlerinde marka deneyimini güçlendiren ikram ve sunum düzeni.',
    details: 'İkram masası, sunum tasarımı, marka atmosferi ve davetli deneyimi.'
  },
  {
    id: 'launch-4',
    title: 'Lansman Oturma Alanı',
    category: 'launch',
    location: 'İstanbul',
    year: '2026',
    image_url: '/images/portfolio/lansman-4.jpeg',
    description: 'Etkinlik öncesi ve sonrası misafir ağırlama için hazırlanan şık oturma alanı.',
    details: 'Lounge alanı, masa düzeni, karşılama ve sosyal alan planlama.'
  },

  {
    id: 'private-1',
    title: 'Özel Kutlama Konsepti',
    category: 'private',
    location: 'İstanbul',
    year: '2026',
    image_url: '/images/portfolio/ozel-1.jpeg',
    description: 'Doğum günü, nişan ve özel kutlamalar için kişiye özel dekoratif alan tasarımı.',
    details: 'Konsept fon, balon, çiçek, fotoğraf alanı ve masa düzeni.'
  },
  {
    id: 'private-2',
    title: 'Butik Özel Davet',
    category: 'private',
    location: 'İstanbul',
    year: '2026',
    image_url: '/images/portfolio/ozel-2.jpeg',
    description: 'Samimi ama etkileyici özel davetler için sıcak ve fotojenik konsept tasarımı.',
    details: 'Dekor, balon, renk paleti, masa ve alan düzeni.'
  },
  {
    id: 'private-3',
    title: 'Çocuk Kutlama Organizasyonu',
    category: 'private',
    location: 'İstanbul',
    year: '2026',
    image_url: '/images/portfolio/ozel-3.jpeg',
    description: 'Renkli, neşeli ve aile odaklı özel kutlama organizasyonu.',
    details: 'Tema tasarımı, çocuk alanı, dekoratif fon ve fotoğraf noktası.'
  },
  {
    id: 'private-4',
    title: 'Özel Parti Kurulumu',
    category: 'private',
    location: 'İstanbul',
    year: '2026',
    image_url: '/images/portfolio/ozel-4.jpeg',
    description: 'Kişisel kutlamalar için dikkat çekici parti alanı ve dekorasyon kurulumu.',
    details: 'Balon dekor, giriş alanı, konsept tasarım ve etkinlik akışı.'
  }
];

const getImageSrc = (url, width = 600) => {
  if (!url) return '';
  if (url.startsWith('/')) return url;
  return `${url}&w=${width}`;
};

const categoryLabel = (cat) => ({
  corporate: 'Kurumsal',
  wedding: 'Düğün',
  launch: 'Lansman',
  private: 'Özel',
  graduation: 'Mezuniyet',
}[cat] || cat);

export default function Portfolio() {
  const [activeFilter, setActiveFilter] = useState('all');
  const [portfolio, setPortfolio] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    setLoading(true);
    axios.get(`${API}/portfolio`)
      .then(res => {
        const data = Array.isArray(res.data) && res.data.length > 0 ? res.data : fallbackPortfolio;
        setPortfolio(data);
        setLoading(false);
      })
      .catch(() => {
        setPortfolio(fallbackPortfolio);
        setLoading(false);
      });
  }, []);

  const filtered = activeFilter === 'all'
    ? portfolio
    : portfolio.filter(item => item.category === activeFilter);

  return (
    <div style={{ backgroundColor: '#070708' }}>
      {/* Hero */}
      <section
        className="relative flex items-end overflow-hidden"
        style={{ minHeight: '50vh', paddingBottom: '5rem', paddingTop: '9rem' }}
      >
        <div
          className="absolute inset-0"
          style={{ background: 'radial-gradient(ellipse 1000px 500px at 30% 50%, rgba(201,168,76,0.06), transparent 60%)' }}
        />
        <div className="relative z-10 container-luxury">
          <motion.span
            className="overline mb-5 block"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.7 }}
          >
            Çalışmalarımız
          </motion.span>
          <motion.h1
            className="display-xl"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.35, duration: 0.85, ease: [0.22,1,0.36,1] }}
          >
            Portföy
          </motion.h1>
        </div>
      </section>

      {/* Filters + Grid */}
      <section className="section-py" style={{ paddingTop: '3rem' }}>
        <div className="container-luxury">
          {/* Filter tabs */}
          <motion.div
            data-testid="portfolio-filters"
            className="flex flex-wrap gap-2 mb-12"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.5 }}
          >
            {filters.map(filter => (
              <button
                key={filter.id}
                onClick={() => setActiveFilter(filter.id)}
                className="font-body text-xs tracking-[0.12em] uppercase px-5 py-2.5 transition-all duration-300"
                style={{
                  backgroundColor: activeFilter === filter.id ? '#C9A84C' : 'transparent',
                  color: activeFilter === filter.id ? '#070708' : 'rgba(245,240,232,0.65)',
                  border: `1px solid ${activeFilter === filter.id ? '#C9A84C' : 'rgba(201,168,76,0.2)'}`,
                }}
              >
                {filter.label}
              </button>
            ))}
          </motion.div>

          {/* Grid */}
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {[...Array(6)].map((_, i) => (
                <div
                  key={i}
                  style={{ height: '300px', backgroundColor: '#0E0F12', border: '1px solid rgba(201,168,76,0.06)', animation: 'pulse 2s ease-in-out infinite' }}
                />
              ))}
            </div>
          ) : (
            <motion.div
              data-testid="portfolio-grid"
              layout
              className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
            >
              <AnimatePresence mode="popLayout">
                {filtered.map((item) => (
                  <motion.div
                    key={item.id}
                    data-testid="portfolio-card"
                    layout
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.95 }}
                    transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                    className="relative overflow-hidden group cursor-pointer img-hover-zoom"
                    style={{
                      height: '320px',
                      backgroundColor: '#0E0F12',
                      border: '1px solid rgba(201,168,76,0.06)',
                    }}
                    onClick={() => setSelected(item)}
                    whileHover={{ borderColor: 'rgba(201,168,76,0.3)' }}
                  >
                    <img
                      src={getImageSrc(item.image_url, 600)}
                      alt={item.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.06]"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 card-overlay opacity-70 group-hover:opacity-90 transition-opacity duration-300" />
                    <div className="absolute inset-0 flex flex-col justify-end p-6">
                      <span className="font-body text-[0.65rem] tracking-[0.18em] uppercase text-[#C9A84C] mb-2 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                        {categoryLabel(item.category)}
                      </span>
                      <h3 className="font-display text-xl font-medium text-[#F5F0E8] mb-1 transform translate-y-1 group-hover:translate-y-0 transition-transform duration-300">
                        {item.title}
                      </h3>
                      <p className="font-body text-xs text-[rgba(245,240,232,0.5)] opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        {item.location} · {item.year}
                      </p>
                    </div>
                  </motion.div>
                ))}
              </AnimatePresence>
            </motion.div>
          )}

          {filtered.length === 0 && !loading && (
            <div className="text-center py-24">
              <Search size={32} className="text-[rgba(201,168,76,0.3)] mx-auto mb-4" />
              <p className="font-body text-sm text-[rgba(245,240,232,0.4)]">Bu kategoride henüz proje bulunmuyor.</p>
            </div>
          )}
        </div>
      </section>

      {/* Project Detail Modal */}
      <AnimatePresence>
        {selected && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
            style={{ backgroundColor: 'rgba(7,7,8,0.92)', backdropFilter: 'blur(20px)' }}
            onClick={() => setSelected(null)}
          >
            <motion.div
              initial={{ opacity: 0, y: 30, scale: 0.97 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 30, scale: 0.97 }}
              transition={{ duration: 0.4, ease: [0.22,1,0.36,1] }}
              className="w-full max-w-3xl overflow-hidden"
              style={{ background: '#0E0F12', border: '1px solid rgba(201,168,76,0.15)' }}
              onClick={e => e.stopPropagation()}
            >
              <div className="relative" style={{ height: '320px' }}>
                <img
                  src={getImageSrc(selected.image_url, 900)}
                  alt={selected.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, transparent 50%, rgba(14,15,18,1) 100%)' }} />
                <button
                  onClick={() => setSelected(null)}
                  className="absolute top-4 right-4 w-8 h-8 rounded-full flex items-center justify-center font-body text-sm transition-colors"
                  style={{ background: 'rgba(7,7,8,0.7)', color: '#F5F0E8', border: '1px solid rgba(201,168,76,0.2)' }}
                >
                  ×
                </button>
              </div>
              <div className="p-8">
                <span className="overline mb-3 block">{categoryLabel(selected.category)}</span>
                <h2 className="font-display text-3xl font-medium text-[#F5F0E8] mb-2">{selected.title}</h2>
                <p className="font-body text-xs text-[rgba(245,240,232,0.45)] mb-6 tracking-wide">{selected.location} · {selected.year}</p>
                <p className="body-text mb-4">{selected.description}</p>
                {selected.details && (
                  <p className="font-body text-sm text-[rgba(245,240,232,0.5)] leading-relaxed">
                    <span className="text-[#C9A84C] font-medium">Kapsam:</span> {selected.details}
                  </p>
                )}
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
